export interface Produto {
  id: string;
  codigo: string;
  nome: string;
  descricao: string | null;
  unidade: string;
  codigo_barras: string | null;
  /** Lote 09/10 (B3): só dígitos (8 e 7); a tela mostra com a máscara. */
  ncm: string | null;
  cest: string | null;
  /** Custo médio móvel, em centavos por unidade. */
  custo_centavos: number;
  preco_centavos: number;
  moeda: string;
  estoque_minimo: number;
  controla_lote: boolean;
  ativo: boolean;
  fornecedor_padrao_id: string | null;
  fornecedor_nome: string | null;
  extras: Record<string, unknown>;
  saldo: number;
  valor_estoque_centavos: number;
  abaixo_minimo: boolean;
  created_at: string;
}

export interface SaldoDetalhado {
  produto_id: string;
  saldo_total: number;
  depositos: { deposito_id: string; deposito_nome: string; saldo: number }[];
  lotes: { lote_id: string; codigo: string; validade: string | null; saldo: number }[];
  linhas: { deposito_id: string; deposito_nome: string; variacao_sku: string | null; lote_codigo: string | null; validade: string | null; saldo: number }[];
}

export interface Deposito {
  id: string;
  nome: string;
  padrao: boolean;
  ativo: boolean;
  locais: { id: string; codigo: string; descricao: string | null }[];
  produtos_em_estoque: number;
  valor_estoque_centavos: number;
}

export interface Atributo {
  id: string;
  nome: string;
  valores: { id: string; valor: string }[];
}

export interface Variacao {
  id: string;
  produto_id: string;
  produto_codigo: string;
  produto_nome: string;
  sku: string;
  valores: Record<string, string>;
  rotulo: string;
  preco_centavos: number | null;
  custo_centavos: number | null;
  preco_efetivo_centavos: number;
  ativo: boolean;
  saldo: number;
}

export type TipoMov = 'entrada' | 'saida' | 'transferencia' | 'ajuste';

export interface Movimentacao {
  id: string;
  tipo: TipoMov;
  sentido: 'entrada' | 'saida' | null;
  produto_id: string;
  produto_codigo: string | null;
  produto_nome: string | null;
  unidade: string | null;
  variacao_sku: string | null;
  deposito_id: string;
  deposito_nome: string;
  deposito_destino_nome: string | null;
  local_codigo: string | null;
  lote_codigo: string | null;
  quantidade: number;
  efeito_total: number;
  custo_unitario_centavos: number;
  valor_centavos: number;
  motivo: string | null;
  data: string;
  autor_nome: string | null;
}

export interface Reposicao {
  id: string;
  codigo: string;
  nome: string;
  unidade: string;
  saldo: number;
  estoque_minimo: number;
  falta: number;
  sugestao_compra: number;
  custo_centavos: number;
  custo_estimado_centavos: number;
  controla_lote: boolean;
  fornecedor_padrao_id: string | null;
  fornecedor_nome: string | null;
}

export type SituacaoLote = 'vencido' | 'vencendo' | 'ok' | 'sem_validade';

export interface Lote {
  id: string;
  produto_id: string;
  produto_codigo: string;
  produto_nome: string;
  unidade: string;
  codigo: string;
  validade: string | null;
  fabricacao: string | null;
  saldo: number;
  situacao: SituacaoLote;
  dias_para_vencer: number | null;
}

export interface Inventario {
  id: string;
  nome: string;
  status: 'aberto' | 'fechado';
  deposito_id: string;
  deposito_nome: string;
  aberto_em: string;
  fechado_em: string | null;
  itens_total: number;
  itens_contados: number;
  itens_com_diferenca: number;
}

export interface ItemInventario {
  id: string;
  produto_id: string;
  produto_codigo: string | null;
  produto_nome: string | null;
  unidade: string | null;
  variacao_id: string | null;
  variacao_sku: string | null;
  lote_id: string | null;
  lote_codigo: string | null;
  saldo_sistema: number;
  quantidade_contada: number | null;
  saldo_fechamento: number | null;
  diferenca: number | null;
}

export interface InventarioDetalhe extends Inventario {
  itens: ItemInventario[];
}

export interface Catalogos {
  unidades: { codigo: string; nome: string; tipo: string }[];
}

/** Lote 09/10 (B3): máscara do NCM (0000.00.00) e do CEST (00.000.00) sobre os dígitos gravados; outro tamanho fica como veio. */
export function mascaraNcm(v: string | null | undefined): string {
  const d = (v ?? '').replace(/\D/g, '');
  return d.length === 8 ? `${d.slice(0, 4)}.${d.slice(4, 6)}.${d.slice(6)}` : (v ?? '');
}
export function mascaraCest(v: string | null | undefined): string {
  const d = (v ?? '').replace(/\D/g, '');
  return d.length === 7 ? `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}` : (v ?? '');
}
